import React, { useState, useEffect } from 'react';
import { Container, Paper, Grid, MenuItem } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { NormalMaterialSwitch } from 'Components/Inputes/NormalMaterialSwitch';
import { LOGOUT } from 'ConstComponents';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import { SelectCMSOfflineDMT as SELECT_CMS_OFFLINEDMT } from 'Components/Api/TransactionReportAPI';
import {
    SelectOnlineDMTValue as SELECT_ONLINEDMT_VALUE,
    UpdateOnlineDMTValue as UPDATE_ONLINEDMT_VALUE
} from 'Components/Api/SettingMasterApi';
import {
    UpdateStatusmanually as STATUS_UPDATE,
    CMSRefundAll as REFUND_ALL,
    DMTCMSTransactionResendAll as RESEND_ALL
} from 'Components/Api/TransactionAPI';
import { SelectForDropDown as PROVIDER_DROP_DOWN } from 'Components/Api/ProviderApi';
import { HeaderPendingSummary } from 'Components/SummaryCards/HeaderPendingSummary';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { CustomModal } from 'Components/Modal/CustomModal';
import { SelectByIDLog } from 'Pages/InnerPages/Report/LogByTransactionMasterID';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
import * as Yup from 'yup';
const CustomContainer = HOCLoader(Container);

export const CMSTransaction = () => {
    const classes = commonStyle();

    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [headerSummary, setHeaderSummary] = useState({});
    const [responseMessage, setResponseMessage] = useState('');
    const [transactionMasterID, setTransactionMasterID] = useState(0);
    const [itemList, setItemList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [consumerNumber, setConsumerNumber] = useState(0);
    const [Amount, setAmount] = useState(0);
    const [isAlertOpenResend, setIsAlertOpenResend] = useState(false);
    const [isAlertOpenRefund, setIsAlertOpenRefund] = useState(false);
    const [providerList, setProviderList] = useState([]);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [
        shouldGetUpdatedDataFromTable,
        setShouldGetUpdatedDataFromTable
    ] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isRefundAllClicked, setIsRefundAllClicked] = useState(false);
    const [isResendAllClicked, setIsResendAllClicked] = useState(false);
    const [isOnlineDMT, setIsOnlineDMT] = useState(true);
    const [selectedIsOnlineDMT, setSelectedIsOnlineDMT] = useState('');

    const [ModelObj, setModelObj] = useState({
        IsOnlineDMT: true,
        FromDate: new Date(),
        ToDate: new Date(),
        ProviderID: 0,
        PaymentType: ''
    });

    const UpdateOnlineDMT = async (values) => {
        setSelectedIsOnlineDMT(values);

        setLoadingOpen(true);

        var jsonObj = {
            IsOnlineDMT: values
        };

        var requestObj = JSON.stringify(jsonObj);

        const response = await UPDATE_ONLINEDMT_VALUE(requestObj);

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);
        setResponseMessage(data);
    };

    const StatusUpdate = async (request) => {
        let jsonObj = {
            TransactionMasterID: request.TransactionMasterID,
            ReferenceNo: request.TxnID,
            Pin: request.Pin,
            Status: request.BtnTitle
        };

        let requestJson = JSON.stringify(jsonObj);

        setIsError(false);
        setLoadingOpen(true);
        const { isAuthorized, status, data } = await STATUS_UPDATE(requestJson);

        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        setResponseMessage(data);

        if (!status) {
            setSeverity('error');
            setIsError(true);
        }
        setSeverity('success');
        setIsError(true);

        SelectPending();
    };
    const selectProvider = async () => {
        setLoading(true);
        const response = await PROVIDER_DROP_DOWN();
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) return;

        var data = JSON.parse(response.data);
        setProviderList(data);
    };
    const SelectPending = async () => {
        let inputObj = {
            FromDate: new Date(),
            ToDate: new Date(),
            ProviderID: 0,
            PaymentType: ''
        };
        var requestObj = JSON.stringify(inputObj);
        setLoadingOpen(true);
        const response = await SELECT_CMS_OFFLINEDMT(requestObj);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        let d = JSON.parse(response.data);
        setHeaderSummary(d.HeaderSummary);
        setItemList(d.list);
    };

    const SelectOnlineDMTValue = async () => {
        setLoadingOpen(true);
        const response = await SELECT_ONLINEDMT_VALUE();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        var data = JSON.parse(response.data);
        setSelectedIsOnlineDMT(data);

        setModelObj({
            ...ModelObj,
            IsOnlineDMT: data.IsOnlineDMT
        });

        setIsOnlineDMT(data.IsOnlineDMT);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'TransactionMasterID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'Name',
            name: 'FirmName'
        });
        columns.push({
            label: 'Provider',
            name: 'ProviderName'
        });

        columns.push({
            label: 'Number',
            name: 'ConsumerNumber'
        });
        columns.push({
            label: 'SenderNo',
            name: 'SenderNo'
        });
        columns.push({
            label: 'Bank',
            name: 'Bank'
        });
        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount'
        });

        columns.push({
            label: 'ProviderRequestID',
            name: 'ProviderRequestID'
        });

        columns.push({
            label: 'PaymentType',
            name: 'PaymentType'
        });
        setMainColumns(columns);
    };

    useEffect(() => {
        if (isInitialLoading) SelectPending();
    }, [isInitialLoading]);

    useEffect(() => {
        createColumns();
        selectProvider();
        SelectPending();
        SelectOnlineDMTValue();
        setLoadingOpen(false);
    }, []);

    const handleRefundAllClick = (e) => {
        setShouldGetUpdatedDataFromTable(true);
        setIsRefundAllClicked(true);
    };
    const handleResendAllClick = (e) => {
        setShouldGetUpdatedDataFromTable(true);
        setIsResendAllClicked(true);
    };

    const RefundAll = async (requestArr) => {
        setIsRefundAllClicked(false);
        if (requestArr.length <= 0) {
            setSeverity('error');
            setResponseMessage(
                'Please select one or more transactions to refund'
            );
            setIsError(true);
            return;
        }
        let request = [];

        requestArr.forEach((element) => {
            let { value } = element[0];
            request.push({ ID: value });
        });

        setLoadingOpen(true);

        let { isAuthorized, status, data } = await REFUND_ALL(
            JSON.stringify(request)
        );
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        let d = JSON.parse(data);

        setResponseMessage(d.Message);

        if (!status) {
            setSeverity('error');
            setIsError(true);
            return;
        }
        setSeverity('success');
        setIsError(true);

        SelectPending();
    };

    const ResendAll = async (requestArr) => {
        setIsResendAllClicked(false);
        if (requestArr.length <= 0) {
            setSeverity('error');
            setResponseMessage(
                'Please select one or more transactions to refund'
            );
            setIsError(true);
            return;
        }
        let request = [];

        requestArr.forEach((element) => {
            let { value } = element[0];
            request.push({ ID: value });
        });

        setLoadingOpen(true);

        let { isAuthorized, status, data } = await RESEND_ALL(
            JSON.stringify(request)
        );
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        let d = JSON.parse(data);

        setResponseMessage(d.Message);

        if (!status) {
            setSeverity('error');
            setIsError(true);
            return;
        }
        setSeverity('success');
        setIsError(true);

        SelectPending();
    };

    const PendingRechargeForm = () => {
        return (
            <Form style={{ marginBottom: '20px' }}>
                <Paper className={classes.PaperStyle}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialDatePickerField
                                    name="FromDate"
                                    label="From Date"
                                    maxDate={new Date()}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialDatePickerField
                                    name="ToDate"
                                    label="To Date"
                                    maxDate={new Date()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialSelect
                                    label="Provider"
                                    name="ProviderID"
                                >
                                    <MenuItem key="0" value="0">
                                        All
                                    </MenuItem>
                                    {providerList.map(
                                        (
                                            { ProviderID, ProviderName },
                                            index
                                        ) => (
                                            <MenuItem
                                                key={index}
                                                value={ProviderID}
                                            >
                                                {ProviderName}
                                            </MenuItem>
                                        )
                                    )}
                                </MaterialSelect>
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialSelect
                                    label="Payment Type"
                                    name="PaymentType"
                                    title="Payment Type"
                                >
                                    <MenuItem
                                        key="ALL"
                                        value="ALL"
                                        selected={true}
                                    >
                                        All Type
                                    </MenuItem>
                                    <MenuItem key="IMPS" value="IMPS">
                                        IMPS
                                    </MenuItem>
                                    <MenuItem key="NEFT" value="NEFT">
                                        NEFT
                                    </MenuItem>
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <PrimaryButton
                                    type="button"
                                    className={classes.CustomPrimaryButtonStyle}
                                    disabled={loadingOpen}
                                    title="Search"
                                    onClick={handleSubmit}
                                >
                                    Resend
                                </PrimaryButton>
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <PrimaryButton
                                    type="button"
                                    className={classes.CustomPrimaryButtonStyle}
                                    disabled={loadingOpen}
                                    title="Resend"
                                    onClick={handleResendAllClick}
                                >
                                    Resend
                                </PrimaryButton>
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <SecondaryButton
                                    type="button"
                                    className={classes.CustomPrimaryButtonStyle}
                                    disabled={loadingOpen}
                                    title="Refund"
                                    onClick={handleRefundAllClick}
                                >
                                    Refund
                                </SecondaryButton>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={2}
                                lg={2}
                                style={{ marginTop: '10px' }}
                            >
                                <NormalMaterialSwitch
                                    label="Online DMT"
                                    name="IsOnlineDMT"
                                    value={isOnlineDMT}
                                    onCustomCallback={(value) => {
                                        setIsOnlineDMT(value);
                                        UpdateOnlineDMT(value);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Form>
        );
    };

    const RefundConfirmation = (
        <ConfirmAlert
            isOpen={isAlertOpenRefund}
            title="Refund Confirmation"
            message="Are you sure to refund this transaction?"
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpenRefund(false);
                StatusUpdate(request);
            }}
            negativeButtonClick={() => {
                setIsAlertOpenRefund(false);
            }}
        />
    );
    const ResendConfirmation = (
        <ConfirmAlert
            isOpen={isAlertOpenResend}
            title="Resend Confirmation"
            message="Are you sure to resend this transaction?"
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpenResend(false);
            }}
            negativeButtonClick={() => {
                setIsAlertOpenResend(false);
            }}
        />
    );

    const PendingDMTList = (
        <ReactTable
            data={itemList}
            columns={mainColumns}
            headerToolbar={false}
            SuccessFailHeader={true}
            primaryIndex={12}
            setLoadingOpen={(value) => {
                setLoadingOpen(value);
            }}
            setIsError={(value) => {
                setIsError(value);
            }}
            setSeverity={(value) => {
                setSeverity(value);
                SelectPending();
            }}
            setResponseMessage={(value) => {
                setResponseMessage(value);
                SelectPending();
            }}
            getUpdatedData={(data) => {
                ProcessUpdatedData(data);
                setShouldGetUpdatedDataFromTable(false);
            }}
            shouldGetUpdatedData={shouldGetUpdatedDataFromTable}
            isSelectableRows={'multiple'}
        />
    );
    const ProcessUpdatedData = (data) => {
        setShouldGetUpdatedDataFromTable(false);

        if (isRefundAllClicked) {
            RefundAll(data);
            return;
        }

        if (isResendAllClicked) {
            ResendAll(data);
            return;
        }
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        //    setLoading(true);
        //  setTableItems([]);
        let requestJSON = JSON.stringify(values);
        setLoadingOpen(true);
        const { data, status, isAuthorized } = await SELECT_CMS_OFFLINEDMT(
            requestJSON
        );
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();
        if (!status) {
            setIsError(true);
            setResponseMessage(data);
            setSeverity('error');
            return;
        }
        var d = JSON.parse(data);

        setItemList(d.list);

        setSubmitting(false);
    };

    const validationSchema = Yup.object({
        FromDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'from date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'from date')
            .typeError(PLEASE_SELECT_VALID + 'from date'),

        ToDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'to date')
            .typeError(PLEASE_SELECT_VALID + 'to date')
    });
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Formik
                        initialValues={ModelObj}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        resetForm={ModelObj}
                        render={PendingRechargeForm}
                    />
                </Grid>
            </Grid>

            {isModalOpen ? (
                <CustomModal
                    isOpen={isModalOpen}
                    title="API Log"
                    width="75%"
                    onDismissCallback={(value) => {
                        setIsModalOpen(value);
                    }}
                >
                    <SelectByIDLog
                        TransactionMasterID={transactionMasterID}
                        ConsumerNumber={consumerNumber}
                        Amount={Amount}
                        setLoading={(value) => setLoadingOpen(value)}
                    />
                </CustomModal>
            ) : null}
            <HeaderPendingSummary headerSummary={headerSummary} />
            {PendingDMTList}
            {isAlertOpenResend ? ResendConfirmation : null}
            {isAlertOpenRefund ? RefundConfirmation : null}
        </CustomContainer>
    );
};
